module.exports = __webpack_public_path__ + "img/file_png.39db65e6.svg";